export default function quickOrder() {
    var wrapper = $('.quick-order');
    var products = wrapper.find('.product');
    var modal = wrapper.find('.add-modal');

    var productId;

    wrapper.on('filter', function(e, current_filters) {
        products.addClass('filter-hidden');

        products.filter(function(i, product) {
            product = $(product);
            var show_product = true;

            $.each(current_filters, function(filter, values) {
                var filter_valid = false;

                if (filter == 'search') {
                    var searchable_text = product.find('.searchable').text().replace(/\s+/g, '').trim().toLowerCase();

                    filter_valid = values[0].toLowerCase().replace(/\s+/g, ' ').trim().split(' ').every(word => {
                        return searchable_text.indexOf(word) != -1;
                    });
                } else {
                    $.each(values, function(i, value) {
                        if (product.hasClass(filter + '-' + value)) {
                            filter_valid = true;

                            return false;
                        }
                    });
                }

                if (!filter_valid) {
                    show_product = false;
                    return false;
                }
            });

            return show_product;
        }).removeClass('filter-hidden');
    });

    products.find('.specsheet-link').attr('target', '_blank');
    products.find('.cart-link').on('click', function(e) {
        e.preventDefault();

        wrapper.addClass('modal');

        var link = $(e.target);

        modal.find('h2').text(link.data('product'));
        modal.find('h3').text(link.data('description'));
        modal.find('.product-image').attr('src', link.data('image'));
        modal.find('.product-brand').attr('src', link.data('brand-logo'));

        productId = link.data('product-id');
    });

    $(document).on('click', function(e) {
        var target = $(e.target);

        if (
            !target.hasClass('add-modal') &&
            !target.hasClass('cart-link') &&
            !target.closest('.add-modal').length
        ) {
            wrapper.removeClass('modal');
        }
    });

    $(document).on('keyup', e => {
        if (e.which == 27) {
            wrapper.removeClass('modal');
        }
    });

    modal.find('form').on('submit', function(e) {
        e.preventDefault();

        $.post(ajax_endpoint, {
            action: 'woocommerce_add_to_cart',
            product_id: productId,
            quantity: $(this).find('.quantity').val()
        }).then(function() {
            $.post(ajax_endpoint, {
                action: 'cart_count'
            }).then(response => {
                $('nav.main .cart-quantity').text(response.data.cart_count);
            });
        });;

        wrapper.removeClass('modal');
    });
}
